module.exports = __webpack_public_path__ + "static/media/19ю102.8a64c92e.webp";